import {Button, Center, Text} from '@chakra-ui/react';
import {useRouter} from 'next/router';

interface PublicCollectionFooterProps {
  btnTitle: string;
  url?: string;
  totalPieces?: number;
}

export const PublicCollectionFooter: React.FC<PublicCollectionFooterProps> = ({
  url,
  btnTitle,
  totalPieces,
}) => {
  const router = useRouter();

  return (
    <Center width="100%" height="100%">
      {totalPieces && totalPieces > 0 ? (
        <Text textStyle="h5" color="black">
          {`${totalPieces} Piece${totalPieces === 1 ? '' : 's'}`}
        </Text>
      ) : (
        <Button
          maxW="243px"
          colorScheme="aqua"
          fontSize="15px"
          lineHeight="15px"
          letterSpacing="-0.42px"
          onClick={() => {
            router.push(url || '');
          }}
        >
          {btnTitle}
        </Button>
      )}
    </Center>
  );
};
